export class SearchHistory {
  history!: string[];
}
